(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      // The search modal is optional now, so this can legitimately find nothing
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-carousel"] && !Shopify.designMode) return;
  try {
    
  class LatestCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.headingGroups = Array.from(this.querySelectorAll('.latest-carousel__heading-group'));
      this.detailGroups = Array.from(this.querySelectorAll('.latest-carousel__details'));
      this.infoGroups = this.headingGroups.concat(this.detailGroups);
      this.infoFrame = null;
      this.headingStack = this.querySelector('.latest-carousel__heading-stack');
      this.detailsStack = this.querySelector('.latest-carousel__details-stack');
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');
      this.total = this.slides.length;
      this.activeIndex = 0;

      if (this.total <= 1) {
        if (this.prevBtn) this.prevBtn.hidden = true;
        if (this.nextBtn) this.nextBtn.hidden = true;
      }

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

      this.slides.forEach((slide) => {
        slide.addEventListener('click', (event) => {
          const index = parseInt(slide.dataset.slide, 10);
          if (index !== this.activeIndex) {
            event.preventDefault();
            this.setActive(index);
          }
        });
      });

      // Reveal the info groups (they start with `hidden` for no-JS) and set
      // their resting state directly, with no transition on first paint.
      this.infoGroups.forEach((group) => {
        group.hidden = false;
        const index = parseInt(group.dataset.slide, 10);
        if (index === this.activeIndex) {
          group.classList.add('is-visible');
        } else {
          group.classList.add('is-offset-right');
        }
      });

      this.sizeStacks();
      this._onResize = () => this.sizeStacks();
      window.addEventListener('resize', this._onResize);

      this.renderSlides();
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this.infoFrame) cancelAnimationFrame(this.infoFrame);
    }

    sizeStacks() {
      if (this.headingStack && this.headingGroups.length) {
        const max = Math.max(...this.headingGroups.map((group) => group.offsetHeight));
        this.headingStack.style.minHeight = max + 'px';
      }
      if (this.detailsStack && this.detailGroups.length) {
        const max = Math.max(...this.detailGroups.map((group) => group.offsetHeight));
        this.detailsStack.style.minHeight = max + 'px';
      }
    }

    go(direction) {
      this.setActive((this.activeIndex + direction + this.total) % this.total, direction);
    }

    setActive(index, direction) {
      if (index === this.activeIndex) return;

      if (typeof direction !== 'number') {
        const diff = (index - this.activeIndex + this.total) % this.total;
        direction = diff === this.total - 1 ? -1 : 1;
      }

      this.activeIndex = index;
      this.renderSlides();
      this.transitionInfo(direction);
    }

    renderSlides() {
      this.slides.forEach((slide) => {
        const index = parseInt(slide.dataset.slide, 10);
        const diff = (index - this.activeIndex + this.total) % this.total;
        const link = slide.querySelector('.latest-carousel__slide-link');
        slide.classList.remove('is-active', 'is-next', 'is-prev', 'is-hidden');

        if (diff === 0) {
          slide.classList.add('is-active');
          if (link) link.setAttribute('tabindex', '0');
        } else if (diff === this.total - 1) {
          slide.classList.add('is-prev');
          if (link) link.setAttribute('tabindex', '-1');
        } else if (diff === 1) {
          slide.classList.add('is-next');
          if (link) link.setAttribute('tabindex', '-1');
        } else {
          slide.classList.add('is-hidden');
          if (link) link.setAttribute('tabindex', '-1');
        }
      });
    }

    // Text crossfades in the same direction the cards move: the outgoing text
    // exits toward the side the active card is heading to, while the incoming
    // text enters from the opposite side.
    //
    // Two things here exist to survive a fast clicker, which is what used to
    // put the text out of step with the sketches:
    //
    //   1. One frame for the whole set, cancelled on the way in. Both stacks
    //      (heading and details) enter together, and the old code scheduled a
    //      frame each while only ever being able to cancel one. A frame left
    //      over from the previous slide would fire afterwards and reveal text
    //      belonging to a sketch that had already been replaced.
    //   2. Everything that isn't the active group is sent out, whether or not
    //      it had finished arriving. A group interrupted mid-entry is still on
    //      screen, and the old `else if (is-visible)` never caught it — so it
    //      sat there while the next one arrived on top.
    transitionInfo(direction) {
      const exitClass = direction === 1 ? 'is-offset-left' : 'is-offset-right';
      const enterClass = direction === 1 ? 'is-offset-right' : 'is-offset-left';

      if (this.infoFrame) {
        cancelAnimationFrame(this.infoFrame);
        this.infoFrame = null;
      }

      const entering = [];

      this.infoGroups.forEach((group) => {
        const index = parseInt(group.dataset.slide, 10);
        group.classList.remove('is-visible', 'is-offset-left', 'is-offset-right', 'is-instant');

        if (index === this.activeIndex) {
          // Transitions off for the move to the enter position. The block is
          // usually parked on the far side — it exited that way a couple of
          // slides ago — and with transitions live that reposition animates
          // instead of jumping. It would then only creep a pixel or two before
          // the next step retargets it, so the text would visibly travel the
          // wrong way while the sketches went the other. This is the bug that
          // showed up as the text being out of step "sometimes": it only
          // happens when the parked side and the enter side disagree.
          group.classList.add('is-instant');
          group.classList.add(enterClass);
          entering.push(group);
        } else {
          group.classList.add(exitClass);
        }
      });

      if (!entering.length) return;

      // Flush the jump while transitions are still off.
      void entering[0].offsetWidth;

      const target = this.activeIndex;
      this.infoFrame = requestAnimationFrame(() => {
        this.infoFrame = null;
        // Superseded while we waited — the newer call owns the text now.
        if (target !== this.activeIndex) return;

        // Transitions back on, flushed before the position changes so the
        // animation starts from the enter position rather than swallowing it.
        entering.forEach((group) => group.classList.remove('is-instant'));
        void entering[0].offsetWidth;

        entering.forEach((group) => {
          group.classList.remove(enterClass);
          group.classList.add('is-visible');
        });
      });
    }
  }

  customElements.define('latest-carousel', LatestCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-establishment"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Videos sitting where a photo would be. They autoplay muted on loop like
    // a moving photo, so controls would be clutter at rest — they're added on
    // hover and focus instead, and left on permanently where there's no hover
    // (touch) or where the reader has asked for reduced motion.
    const canHover = window.matchMedia('(hover: hover)').matches;
    const stillPreferred = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-hover-video] video').forEach((video) => {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      if (stillPreferred) {
        video.autoplay = false;
        video.pause();
        video.controls = true;
        return;
      }

      if (!canHover) {
        video.controls = true;
        return;
      }

      const frame = video.closest('[data-hover-video]');
      const show = () => { video.controls = true; };
      const hide = () => { video.controls = false; };

      hide();
      frame.addEventListener('mouseenter', show);
      frame.addEventListener('mouseleave', hide);
      video.addEventListener('focus', show);
      video.addEventListener('blur', hide);

      // Autoplay can be refused (low power mode, data saver). Falling back to
      // controls means the reader still has a way to start it.
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(() => { video.controls = true; });
      }
    });

    // Carousel. Registered BEFORE the lightbox so a click on an off-centre
    // photo can stop the event there and re-centre instead of opening it.
    document.querySelectorAll('[data-carousel]').forEach((root) => {
      const viewport = root.querySelector('[data-carousel-viewport]');
      const track = root.querySelector('[data-carousel-track]');
      const slides = Array.from(root.querySelectorAll('[data-carousel-item]'));
      if (!track || slides.length === 0) return;

      // Start on the middle photo so both arrows are useful straight away.
      let index = Math.floor((slides.length - 1) / 2);

      const layout = () => {
        const active = slides[index];
        // offsetLeft is measured against the track (position: relative), and
        // transforms don't move it — so the scaled neighbours never skew this.
        const offset = active.offsetLeft + active.offsetWidth / 2 - viewport.clientWidth / 2;
        track.style.transform = `translateX(${-offset}px)`;
        slides.forEach((slide, i) => {
          const isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      // Wraps in both directions, so the ends are never dead.
      const go = (next) => {
        index = (next + slides.length) % slides.length;
        layout();
      };

      slides.forEach((slide, i) => {
        slide.addEventListener('click', (event) => {
          if (i === index) return; // centred already — let the lightbox have it
          event.preventDefault();
          event.stopImmediatePropagation();
          go(i);
        });
      });

      const prev = root.querySelector('[data-carousel-prev]');
      const next = root.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', () => go(index - 1));
      if (next) next.addEventListener('click', () => go(index + 1));

      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1); }
      });

      // Slide widths are percentages, so the centring has to be recomputed
      // whenever the viewport changes. Images finishing late shift nothing —
      // the frames are a fixed ratio — but resize and font swaps do.
      let frame;
      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(layout);
      });

      layout();
      window.requestAnimationFrame(layout);
    });

    // Lightbox behaviour now lives in assets/lightbox.js (loaded at the top of
    // this section) so the product page's place gallery can share it rather
    // than keep a second copy. Shopify's section-JS bundle is a deferred
    // script in <head> and that <script> tag is in the body, so this carousel
    // still registers its click handler first — which is what keeps a click on
    // an off-centre slide moving the carousel instead of opening the viewer.

    document.querySelectorAll('[data-shop-list]').forEach((wrapper) => {
      const list = wrapper.querySelector('.article-shop-list__items');
      const display = wrapper.querySelector('[data-shop-display]');
      const count = parseInt(wrapper.dataset.shopCount, 10) || 6;

      if (list && display) {
        // Row N pairs with image N, so both lists have to be trimmed and
        // reordered together — the hover handler below matches them by index.
        const rows = Array.from(list.children);
        const pics = Array.from(display.children);
        const order = rows.map((row, index) => index);

        if (wrapper.hasAttribute('data-shop-shuffle')) {
          for (let i = order.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const swap = order[i];
            order[i] = order[j];
            order[j] = swap;
          }
        }

        const keep = order.slice(0, count);
        const keeping = new Set(keep);

        rows.forEach((row, index) => {
          if (keeping.has(index)) return;
          row.remove();
          if (pics[index]) pics[index].remove();
        });

        // Re-appending moves the survivors into the drawn order, so the six on
        // show aren't always in catalogue sequence either.
        keep.forEach((index) => {
          list.appendChild(rows[index]);
          if (pics[index]) display.appendChild(pics[index]);
        });

        // Whatever survived is on show now, and needs its photo.
        wrapper.querySelectorAll('.article-shop-list__item--overflow').forEach((el) => {
          el.classList.remove('article-shop-list__item--overflow');
        });
        wrapper.querySelectorAll('.article-shop-list__display-image--overflow').forEach((el) => {
          el.classList.remove('article-shop-list__display-image--overflow');
        });
        wrapper.querySelectorAll('[data-shop-display] img[data-src]').forEach((img) => {
          if (!img.getAttribute('src')) img.src = img.dataset.src;
        });

        // The resting state belongs to whichever row landed first.
        wrapper.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));
        if (list.firstElementChild) list.firstElementChild.classList.add('is-active');
        if (display.firstElementChild) display.firstElementChild.classList.add('is-active');
      }

      const items = wrapper.querySelectorAll('[data-shop-item]');
      const images = wrapper.querySelectorAll('[data-shop-display] img');

      items.forEach((item, index) => {
        const activate = () => {
          items.forEach((el) => el.closest('.article-shop-list__item').classList.remove('is-active'));
          images.forEach((img) => img.classList.remove('is-active'));

          item.closest('.article-shop-list__item').classList.add('is-active');
          if (images[index]) {
            images[index].classList.add('is-active');
          }
        };

        item.addEventListener('mouseenter', activate);
        item.addEventListener('focus', activate);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-shop-list]').forEach((wrapper) => {
      const items = wrapper.querySelectorAll('[data-shop-item]');
      const images = wrapper.querySelectorAll('[data-shop-display] img');

      items.forEach((item, index) => {
        const activate = () => {
          items.forEach((el) => el.closest('.article-shop-list__item').classList.remove('is-active'));
          images.forEach((img) => img.classList.remove('is-active'));

          item.closest('.article-shop-list__item').classList.add('is-active');
          if (images[index]) {
            images[index].classList.add('is-active');
          }
        };

        item.addEventListener('mouseenter', activate);
        item.addEventListener('focus', activate);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Tag chips swap the section in place instead of reloading the page, so
  // scroll position survives. Falls back to normal navigation on any error.
  (() => {
    const SEL = '.collection-tag-cloud__tag';

    const sectionEl = (id) => document.getElementById('shopify-section-' + id);

    const swap = (url, id) =>
      fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(id))
        .then((r) => {
          if (!r.ok) throw new Error('bad response');
          return r.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
          const current = sectionEl(id);
          if (!fresh || !current) throw new Error('section missing');
          current.innerHTML = fresh.innerHTML;
        });

    document.addEventListener('click', (event) => {
      const link = event.target.closest(SEL);
      if (!link) return;
      // Let modified clicks (new tab, download…) behave normally
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const nav = link.closest('[data-tag-nav]');
      if (!nav) return;
      const id = nav.dataset.sectionId;
      const url = link.href;
      if (!id) return;

      event.preventDefault();
      const wrapper = sectionEl(id);
      if (wrapper) wrapper.setAttribute('data-tag-loading', '');

      swap(url, id)
        .then(() => {
          history.pushState({ tagNav: id }, '', url);
        })
        .catch(() => {
          window.location.href = url; // something went wrong — just navigate
        })
        .finally(() => {
          const w = sectionEl(id);
          if (w) w.removeAttribute('data-tag-loading');
        });
    });

    // Back/forward should move between filters without a full reload either
    window.addEventListener('popstate', (event) => {
      const id = event.state && event.state.tagNav;
      if (!id || !sectionEl(id)) return;
      swap(window.location.href, id).catch(() => window.location.reload());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  // Client-side guard so a bad address shakes immediately instead of round
  // tripping through a page reload. The browser's own check is loose — "a@b"
  // passes it — so this uses the same shape the worker enforces on the
  // suggestion forms, keeping both surfaces consistent.
  (() => {
    const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

    const shake = (row) => {
      if (!row) return;
      row.classList.remove('is-error');
      void row.offsetWidth; // restart the animation mid-run
      row.classList.add('is-error');
    };

    const say = (form, text) => {
      const msg = form.querySelector('[data-newsletter-message]');
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
    };

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target.closest('.newsletter-signup__form');
        if (!form) return;
        const input = form.querySelector('input[type="email"]');
        if (!input) return;
        const value = input.value.trim();
        if (EMAIL.test(value)) {
          say(form, '');
          return;
        }
        event.preventDefault();
        shake(form.querySelector('.newsletter-signup__row'));
        say(form, value ? "That address doesn't look right." : 'An email address, first.');
        input.focus();
      },
      true
    );

    // A server-side rejection arrives with the page, so shake it on arrival
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-newsletter-server-error]').forEach((err) => {
        const form = err.closest('.newsletter-signup__form');
        shake(form && form.querySelector('.newsletter-signup__row'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // ---- Click-to-play for the intro film ----
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-process-video-trigger]');
      if (!trigger) return;
      const url = trigger.dataset.videoUrl;
      if (!url) return;
      const video = document.createElement('video');
      video.src = url;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.className = 'process-steps__media-video';
      trigger.replaceWith(video);
    });

    // ---- Scroll interaction ----
    // Two cheap effects, both transform-only so they never trigger layout:
    // media fades and rises as it enters, and drifts gently against the
    // scroll while it's on screen. Honours prefers-reduced-motion, and the
    // scroll handler only ever walks elements currently in view.
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const media = Array.from(document.querySelectorAll('[data-scroll-media]'));
    if (!media.length) return;

    if (!('IntersectionObserver' in window) || reduce.matches) {
      media.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const onScreen = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            onScreen.add(entry.target);
          } else {
            onScreen.delete(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );
    media.forEach((el) => io.observe(el));

    let queued = false;
    const drift = () => {
      queued = false;
      const h = window.innerHeight;
      onScreen.forEach((el) => {
        const r = el.getBoundingClientRect();
        // -0.5 at the bottom of the viewport, +0.5 at the top
        const progress = 0.5 - (r.top + r.height / 2) / h;
        el.style.setProperty('--drift', (progress * 28).toFixed(1) + 'px');
      });
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(drift);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    queue();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sketch-carousel"] && !Shopify.designMode) return;
  try {
    
  // Arrow carousel: scrolls by one card width, arrows appear only when there
  // is somewhere to go. Shared by every "More from…" row on the page.
  (() => {
    const setup = (root) => {
      const viewport = root.querySelector('[data-carousel-viewport]');
      const track = root.querySelector('[data-carousel-track]');
      const prev = root.querySelector('[data-carousel-prev]');
      const next = root.querySelector('[data-carousel-next]');
      if (!viewport || !track) return;

      // Draw the row from the rendered pool. Liquid marks everything past the
      // display count as overflow and hides it; we pick which ones survive,
      // drop the rest, then reveal what's left. Running twice is harmless —
      // once trimmed, the pool is already at the display count.
      const show = parseInt(track.dataset.show, 10) || 0;
      const cards = Array.from(track.children);

      if (show && cards.length > show) {
        const order = cards.map((card, index) => index);

        if (track.hasAttribute('data-shuffle')) {
          for (let i = order.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const swap = order[i];
            order[i] = order[j];
            order[j] = swap;
          }
        }

        const keep = order.slice(0, show);
        const keeping = new Set(keep);

        cards.forEach((card, index) => {
          if (!keeping.has(index)) card.remove();
        });

        // Re-appending puts the survivors in the drawn order, so the row isn't
        // always in catalogue sequence either.
        keep.forEach((index) => track.appendChild(cards[index]));
      }

      track.querySelectorAll('.sketch-carousel__item--overflow').forEach((card) => {
        card.classList.remove('sketch-carousel__item--overflow');
      });

      const step = () => {
        const first = track.querySelector('[data-carousel-item]');
        if (!first) return viewport.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      };

      // The ends loop instead of dead-ending: next from the last card returns
      // to the first, prev from the first jumps to the last. The 8px tolerance
      // covers fractional scroll positions on zoomed or scaled displays.
      const go = (direction) => {
        const end = track.scrollWidth - viewport.clientWidth;
        const x = viewport.scrollLeft;

        if (direction > 0 && x >= end - 8) viewport.scrollTo({ left: 0, behavior: 'smooth' });
        else if (direction < 0 && x <= 8) viewport.scrollTo({ left: end, behavior: 'smooth' });
        else viewport.scrollBy({ left: direction * step(), behavior: 'smooth' });
      };

      const sync = () => {
        // Both arrows stay for as long as there is anywhere to go — reaching an
        // end is no longer a reason to hide one.
        const overflow = track.scrollWidth - viewport.clientWidth > 4;
        if (prev) prev.hidden = !overflow;
        if (next) next.hidden = !overflow;
      };

      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));
      viewport.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    };

    const init = () => document.querySelectorAll('.sketch-carousel [data-carousel]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-list"] && !Shopify.designMode) return;
  try {
    
  // Cursor-following reveal, in the spirit of Tympanus' effect 3.
  //
  // The image chases the pointer on a spring — each frame it closes a
  // fraction of the remaining distance, which is what reads as weight — and
  // enters by wiping up from its bottom edge instead of fading, so it looks
  // drawn onto the page.
  //
  // Every service image is already in the DOM as its own layer, so switching
  // rows moves between layers instead of swapping a src (which would flash on
  // first hover while the new file downloaded).
  //
  // Layers never cross-fade. Arriving and leaving both clip downward, so a
  // row-to-row change is one edge sweeping down the frame — new image above
  // it, old image below.
  //
  // Only transform and clip-path animate, inside one rAF loop that idles when
  // nothing is hovered.
  (() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('.services-list').forEach((root) => {
      const follower = root.querySelector('[data-service-follower]');
      const layers = root.querySelectorAll('[data-follower-slot]');
      const rows = root.querySelectorAll('[data-service]');
      if (!follower || !layers.length || !rows.length) return;

      let targetX = 0;
      let targetY = 0;
      let x = 0;
      let y = 0;
      let active = false;
      let running = false;

      const EASE = 0.14; // fraction of the gap closed per frame

      const frame = () => {
        const dx = targetX - x;
        const dy = targetY - y;
        x += dx * EASE;
        y += dy * EASE;
        follower.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        if (active || Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
          requestAnimationFrame(frame);
        } else {
          running = false;
        }
      };

      const start = () => {
        if (running) return;
        running = true;
        requestAnimationFrame(frame);
      };

      const LEAVE_MS = reduce.matches ? 250 : 600;
      let current = null;

      // Hand the outgoing layer to `is-leaving` rather than just switching it
      // off. Both classes clip downward (see the stylesheet), so the two read
      // as a single edge travelling down the frame rather than one image
      // fading under another. The class comes off once the wipe is done — the
      // two clipped end states interpolate through zero height, so that reset
      // is invisible wherever it lands.
      const dismiss = (layer) => {
        layer.classList.remove('is-active');
        layer.classList.add('is-leaving');
        clearTimeout(layer.leaveTimer);
        layer.leaveTimer = setTimeout(() => layer.classList.remove('is-leaving'), LEAVE_MS);
      };

      // The frame takes the ratio of whichever image is arriving, so nothing
      // is cropped and portrait and landscape shots both sit correctly.
      const show = (index) => {
        const next = root.querySelector(`[data-follower-slot="${index}"]`);
        if (!next || next === current) return;

        if (current) dismiss(current);

        // Coming back to a row that is still on its way out: return it to the
        // waiting state and force a reflow, so it wipes in from the top rather
        // than snapping back whole.
        if (next.classList.contains('is-leaving')) {
          clearTimeout(next.leaveTimer);
          next.classList.remove('is-leaving');
          void next.offsetWidth;
        }

        next.classList.add('is-active');
        current = next;

        if (next.naturalWidth && next.naturalHeight) {
          follower.style.setProperty(
            '--ar',
            (next.naturalWidth / next.naturalHeight).toFixed(4)
          );
        }
      };

      // Leaving a row and leaving the list are the same exit: the image clears
      // downward. Left to CSS alone it would retreat back up the way it came,
      // since the resting state sits above the frame.
      const hide = () => {
        active = false;
        follower.classList.remove('is-visible');
        if (current) {
          dismiss(current);
          current = null;
        }
      };

      root.addEventListener('pointermove', (event) => {
        targetX = event.clientX;
        targetY = event.clientY;
        if (active) start();
      });

      rows.forEach((row) => {
        const index = row.dataset.serviceIndex;
        if (index === undefined) return;
        const layer = root.querySelector(`[data-follower-slot="${index}"]`);
        if (!layer) return;

        row.addEventListener('pointerenter', (event) => {
          // Jump to the pointer on first entry so the image doesn't fly in
          // from wherever it was last left
          if (!active) {
            x = targetX = event.clientX;
            y = targetY = event.clientY;
            follower.style.transform = `translate3d(${x}px, ${y}px, 0)`;
          }
          show(index);
          active = true;
          follower.classList.add('is-visible');
          if (!reduce.matches) start();
        });

        // Moving between rows fires this before the next row's pointerenter,
        // so the outgoing image starts clearing and the incoming one starts
        // arriving on the same frame — which is the whole point.
        row.addEventListener('pointerleave', hide);
      });

      root.addEventListener('pointerleave', hide);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-poll"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const list = document.querySelector('[data-poll-endpoint]');
    if (!list) return;
    const endpoint = (list.dataset.pollEndpoint || '').trim();
    const round = list.dataset.pollRound || 'homepage';
    const LOCK_KEY = 'sxe-poll-voted-' + round;

    // One vote PER PLACE per person, and clicking a voted place again
    // withdraws that vote. The lock is a list of option handles.
    const readVoted = () => {
      try {
        const raw = window.localStorage.getItem(LOCK_KEY);
        if (!raw) return [];
        if (raw[0] === '[') return JSON.parse(raw);
        if (raw === '1') return []; // old whole-poll lock, no pick recorded
        return [raw]; // old single-vote lock
      } catch (e) { return []; }
    };
    const saveVoted = (arr) => {
      try { window.localStorage.setItem(LOCK_KEY, JSON.stringify(arr)); } catch (e) {}
    };
    let voted = readVoted();

    // ---- Turnstile ----
    // Invisible until something looks scripted. Absent site key, absent
    // script, or a timeout all resolve to '' — the worker treats that as
    // "no challenge", which it only rejects when its secret is configured.
    const tsEl = document.querySelector('[data-turnstile]');
    const SITEKEY = tsEl ? (tsEl.dataset.sitekey || '') : '';
    let tsWidget = null;
    let tsResolve = null;

    const whenTurnstile = () =>
      new Promise((resolve) => {
        if (window.turnstile) return resolve(window.turnstile);
        let tries = 0;
        const poll = setInterval(() => {
          if (window.turnstile) { clearInterval(poll); resolve(window.turnstile); }
          else if (++tries > 100) { clearInterval(poll); resolve(null); } // ~10s
        }, 100);
      });

    const challenge = async () => {
      if (!SITEKEY || !tsEl) return '';
      const ts = await whenTurnstile();
      if (!ts) return '';
      const settle = (token) => {
        const r = tsResolve;
        tsResolve = null;
        if (r) r(token || '');
      };
      if (tsWidget === null) {
        try {
          tsWidget = ts.render(tsEl, {
            sitekey: SITEKEY,
            execution: 'execute',
            appearance: 'interaction-only',
            callback: settle,
            'error-callback': () => settle(''),
            'timeout-callback': () => settle(''),
          });
        } catch (e) { return ''; }
      }
      return new Promise((resolve) => {
        tsResolve = resolve;
        try { ts.reset(tsWidget); } catch (e) {}
        try { ts.execute(tsWidget); } catch (e) { settle(''); }
        setTimeout(() => { if (tsResolve === resolve) settle(''); }, 12000);
      });
    };

    const paint = (counts) => {
      // Bars scale against a fixed target (the section's "votes needed to
      // fill a bar" setting), so a bar's length always means the same thing.
      list.querySelectorAll('[data-poll-option]').forEach((item) => {
        const n = counts[item.dataset.pollOption] || 0;
        const btn = item.querySelector('[data-vote-btn]');
        const max = parseFloat(btn && btn.dataset.max) || 20;
        const bar = item.querySelector('[data-vote-bar]');
        if (bar) bar.style.width = Math.min((n / max) * 100, 100) + '%';
        if (btn) btn.dataset.count = n;
      });
    };

    const lockItem = (item, mine) => {
      const b = item.querySelector('[data-vote-btn]');
      if (!b) return;
      b.disabled = false; // stays clickable: a voted place can be un-voted
      b.classList.add(mine ? 'is-voted' : 'is-locked');
      // Label stays "+1" whatever the state — the gold fill is the signal.
      b.setAttribute('aria-disabled', mine ? 'false' : 'true');
      if (mine) b.setAttribute('aria-label', 'Remove your vote for ' + (item.querySelector('.travel-poll__item-name') || {}).textContent);
    };

    const unlockItem = (item) => {
      const b = item.querySelector('[data-vote-btn]');
      if (!b) return;
      b.classList.remove('is-voted', 'is-locked');
      b.removeAttribute('aria-disabled');
      const name = item.querySelector('.travel-poll__item-name');
      if (name) b.setAttribute('aria-label', 'Vote for ' + name.textContent);
      b.disabled = false;
    };

    const paintLocks = () => {
      list.querySelectorAll('[data-poll-option]').forEach((item) => {
        if (voted.indexOf(item.dataset.pollOption) !== -1) lockItem(item, true);
      });
    };

    const shake = (item) => {
      item.classList.remove('is-error');
      void item.offsetWidth; // restart the animation if it's mid-run
      item.classList.add('is-error');
    };

    if (endpoint) {
      fetch(endpoint + '?round=' + encodeURIComponent(round))
        .then((r) => r.json())
        .then((data) => { if (data && data.counts) paint(data.counts); })
        .catch(() => {});
      paintLocks();
    }

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-vote-btn]');
      if (!btn || btn.disabled) return;
      const item = btn.closest('[data-poll-option], .travel-poll__item');
      if (!item) return;

      // Locked = someone else on this connection voted here; nothing to undo
      if (btn.classList.contains('is-locked')) {
        shake(item);
        return;
      }
      const isUnvote = btn.classList.contains('is-voted');

      if (!endpoint) {
        // Demo mode — no endpoint configured, local-only toggle
        const bar = item.querySelector('[data-vote-bar]');
        const max = parseFloat(btn.dataset.max) || 1;
        const count = Math.max((parseFloat(btn.dataset.count) || 0) + (isUnvote ? -1 : 1), 0);
        btn.dataset.count = count;
        if (bar) bar.style.width = Math.min((count / max) * 100, 100) + '%';
        if (isUnvote) unlockItem(item); else lockItem(item, true);
        return;
      }

      btn.disabled = true;
      challenge()
        .then((cf) =>
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              round: round,
              option: item.dataset.pollOption,
              remove: isUnvote,
              cf: cf,
            }),
          })
        )
        .then((r) => r.json().then((data) => ({ status: r.status, data })))
        .then(({ status, data }) => {
          if (data && data.counts) paint(data.counts);
          btn.disabled = false;
          if (status === 200) {
            if (isUnvote) {
              voted = voted.filter((v) => v !== item.dataset.pollOption);
              saveVoted(voted);
              unlockItem(item);
            } else {
              voted.push(item.dataset.pollOption);
              saveVoted(voted);
              lockItem(item, true);
            }
          } else if (status === 429 && !isUnvote) {
            lockItem(item, false);
            shake(item);
          } else {
            // e.g. un-vote after the hour window closed — the vote is final
            shake(item);
          }
        })
        .catch(() => {
          btn.disabled = false;
          shake(item);
        });
    });

  });

  } catch(e) { console.error(e); }
})();
})();
